import { Link } from 'react-router-dom';
import hillsImage from '@/media/images/Hills - Robert Bye.jpg';
import bakeryImage from '@/media/images/Bakery - Yeh Xintong.jpg';
import eleanorProfilePhoto from '@/media/images/Dockside_Design_Eleanor_Profile.jpeg';
import camProfilePhoto from '@/media/images/Dockside_Design_Cam_Profile.jpeg';
import docksideWidePhoto from '@/media/images/Dockside_Design_Home_Dockside_Wide.jpeg';
import cafeImage from '@/media/images/Cafe - Keghan Crossland.jpg';
import pubImage from '@/media/images/Pub - Nikola Jovanovic.jpg';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { motion } from 'framer-motion';
import {
  Globe,
  Utensils,
  Wrench,
  RefreshCw,
  Server,
  ShoppingBag,
  MessageSquare,
  Paintbrush,
  Rocket,
  HeartHandshake,
  ChevronRight,
  Check,
  Quote,
  ArrowDown
} from 'lucide-react';

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: 'easeOut' }
};

const staggerContainer = {
  initial: {},
  whileInView: {
    transition: {
      staggerChildren: 0.1
    }
  },
  viewport: { once: true }
};

const services = [
  { icon: Globe, title: 'Business Websites', desc: 'Professional sites that attract customers and build trust.' },
  { icon: Utensils, title: 'Restaurant & Bar Sites', desc: 'Menus, bookings, and atmosphere — all in one place.' },
  { icon: Wrench, title: 'Service Company Sites', desc: 'Showcase your work and make it easy to get in touch.' },
  { icon: ShoppingBag, title: 'Online Stores', desc: 'Sell products with Stripe-powered checkout, product management, and orders.' },
  { icon: RefreshCw, title: 'Website Redesigns', desc: 'Refresh your tired site with a modern, mobile-friendly design.' },
  { icon: Server, title: 'Hosting & Support', desc: 'Reliable hosting with ongoing support included.' },
];

const portfolioItems = [
  {
    image: bakeryImage,
    title: 'The Local Bakery',
    type: 'Café',
    desc: 'A warm, inviting site showcasing fresh bakes and daily specials.'
  },
  {
    image: cafeImage,
    title: 'The Corner Café',
    type: 'Restaurant',
    desc: 'Modern design with online menu and table booking integration.'
  },
  {
    image: pubImage,
    title: 'Bloom & Wild',
    type: 'Boutique',
    desc: 'Beautiful gallery-style site highlighting floral arrangements.'
  },
];

const steps = [
  { icon: MessageSquare, title: 'Quick Chat', desc: 'Tell us about your business and what you need.' },
  { icon: Paintbrush, title: 'We Design & Build', desc: 'We create your site with your input along the way.' },
  { icon: Rocket, title: 'Review & Launch', desc: 'You review, we refine, then we go live.' },
  { icon: HeartHandshake, title: 'Ongoing Support', desc: 'We stick around to keep everything running smoothly.' },
];

const packages = [
  {
    name: 'Starter',
    price: '\u00a399',
    maintainPrice: '\u00a369',
    note: '14-day refund \u00b7 12-month Launch year',
    description: 'A professional website with hosting, security, and support.',
    features: ['Up to 5 pages', 'Semi-custom design', 'You provide content', 'Standard support', '2 change requests/month'],
    cta: 'Get Started',
  },
  {
    name: 'Business',
    price: '\u00a3149',
    maintainPrice: '\u00a399',
    note: '14-day refund \u00b7 12-month Launch year',
    description: 'A fully custom site with content support and 2 add-ons of your choice.',
    features: ['Up to 10 pages', 'Fully custom design', 'Content assistance', 'Priority support', '2 add-ons included', '5 change requests/month'],
    cta: 'Start Your Project',
    popular: true,
  },
  {
    name: 'Pro',
    price: '\u00a3229',
    maintainPrice: '\u00a3159',
    note: '14-day refund \u00b7 12-month Launch year',
    description: 'A bespoke site with content writing and every add-on we offer included.',
    features: ['Unlimited pages', 'Bespoke design', 'We write your content', 'Same-day support', 'All 6 add-ons included', '10 change requests/month'],
    cta: 'Go Pro',
  },
  {
    name: 'Commerce',
    price: '\u00a3299',
    note: '+ 1.5% txn fee \u00b7 14-day refund',
    eligibility: 'UK businesses only',
    description: 'Everything in Pro plus a fully managed online store powered by Stripe.',
    features: ['Everything in Pro', 'Stripe-hosted checkout', 'Up to 100 products', 'Order management & refunds', '15 priority change requests/month'],
    cta: 'Open Your Store',
    commerce: true,
  },
];

// Currently disabled and replaced the section with the HereFromUs bit
// const testimonials = [
//   {
//     quote: "Dockside Design transformed our online presence. Our bookings have doubled since launching the new site!",
//     name: "Sarah Mitchell",
//     role: "Owner, The Corner Café",
//     image: "https://images.unsplash.com/photo-1758598304332-94b40ce7c7b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxmcmllbmRseSUyMHByb2Zlc3Npb25hbCUyMHBlcnNvbiUyMHBvcnRyYWl0JTIwbmF0dXJhbCUyMGxpZ2h0fGVufDB8fHx8MTc3MTExMjYzOXww&ixlib=rb-4.1.0&q=85"
//   },
//   {
//     quote: "Finally, a web studio that understands small businesses. No jargon, just results. Highly recommended.",
//     name: "James Wilson",
//     role: "Director, Wilson Plumbing",
//     image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces"
//   },
// ];

const hereFromUs = [
    {
        quote: "Eleanor is Co-Founder of Dockside Studio, where she sits at the intersection of design and client experience — managing relationships, leading sales, and shaping front-end design to ensure every project delivers on its promise. A Gloucester Docks resident for three years and a regular across its iconic pubs, bars, and cafes.",
        name: "Eleanor R",
        role: "Co-Founder & Account Manager",
        image: eleanorProfilePhoto
    },
    {
        quote: "Cameron is Co-Founder of Dockside Studio, where he leads the technical side of every project — building, deploying, and maintaining the platforms that power each client's online presence. When he's not building for clients, he's building for fun — coding is as much a hobby as it is a profession. Outside of the screen, you'll find him out on a run or enjoying Gloucester's live music scene.",
        name: "Cameron S",
        role: "Co-Founder & Website Developer",
        image: camProfilePhoto
    },
];

const Home = () => {
  return (
    <div data-testid="home-page">
      {/* Hero Section - Mobile */}
      <section className="md:hidden relative overflow-hidden">
        <div className="relative h-[70vh] min-h-[500px]">
          <img
            src={docksideWidePhoto}
            alt="Dockside Design"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-primary/60" />
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="absolute inset-0 flex flex-col items-center justify-center text-center px-6"
          >
            <h1 className="font-heading text-4xl font-bold text-white leading-tight mb-4">
              Dockside Design
            </h1>
            <p className="text-white/90 text-lg mb-8 max-w-sm">
              Modern websites for local businesses — built fast and delivered professionally.
            </p>
            <div className="flex flex-col gap-3 w-full max-w-xs">
              <Button
                asChild
                data-testid="hero-see-work-btn-mobile"
                className="bg-accent text-accent-foreground hover:bg-accent/90 rounded-full px-8 py-6 text-lg font-medium shadow-md"
              >
                <Link to="/portfolio">See Our Work</Link>
              </Button>
              <Button
                asChild
                variant="outline"
                data-testid="hero-quote-btn-mobile"
                className="rounded-full px-8 py-6 text-lg font-medium border-2 border-white text-white hover:bg-white/10"
              >
                <Link to="/contact">Get a Quote</Link>
              </Button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Hero Section - Desktop */}
      <section className="hidden md:block relative overflow-hidden py-16 md:py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div {...fadeInUp}>
              <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-primary leading-tight mb-6">
                Modern websites for local businesses — built fast and done professionally.
              </h1>
              <p className="text-lg text-muted-foreground mb-8 max-w-xl">
                Dockside Design helps cafés, shops, venues and small businesses get a professional 
                online presence without the agency hassle.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  asChild
                  data-testid="hero-see-work-btn"
                  className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 py-6 text-lg font-medium shadow-md transition-all hover:scale-105"
                >
                  <Link to="/portfolio">See Our Work</Link>
                </Button>
                <Button
                  asChild
                  variant="outline"
                  data-testid="hero-quote-btn"
                  className="rounded-full px-8 py-6 text-lg font-medium border-2"
                >
                  <Link to="/contact">Get a Quote</Link>
                </Button>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="relative hidden lg:block"
            >
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                    src={docksideWidePhoto}
                    alt="Robert Bye Hills"
                    className="w-full h-auto object-cover aspect-[4/3]"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-accent text-accent-foreground px-6 py-4 rounded-xl shadow-lg">
                <p className="font-heading font-bold text-xl">Design attracts attention. Performance earns trust.</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 md:py-24 bg-muted/30">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div {...fadeInUp} className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-6">
              About Dockside Design
            </h2>
            <p className="text-lg text-muted-foreground mb-6">
              We're an independent web studio based in the UK, focused on one thing: 
              helping local businesses look professional online.
            </p>
            <p className="text-muted-foreground">
              No corporate nonsense. No months of waiting. Just practical, effective 
              websites that bring customers through your door. We keep things simple 
              and focused on what actually works.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div {...fadeInUp} className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">
              What We Do
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Everything you need to get your business online properly.
            </p>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {services.map((service, index) => (
              <motion.div key={index} variants={fadeInUp}>
                <Card className="h-full bg-card hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border-border/50">
                  <CardContent className="p-6 md:p-8">
                    <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center mb-4">
                      <service.icon className="w-6 h-6 text-accent" />
                    </div>
                    <h3 className="font-heading text-xl font-semibold text-foreground mb-2">
                      {service.title}
                    </h3>
                    <p className="text-muted-foreground">{service.desc}</p>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Portfolio Preview */}
      <section className="py-16 md:py-24 bg-primary text-primary-foreground">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div {...fadeInUp} className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
            <div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4">
                Perfect For Every Business
              </h2>
              <p className="text-primary-foreground/80 max-w-xl">
                Take a look at some of the websites we've built
              </p>
            </div>
            <Button
              asChild
              variant="outline"
              data-testid="view-all-portfolio-btn"
              className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10 rounded-full w-fit"
            >
              <Link to="/portfolio">
                View All <ChevronRight className="ml-2 w-4 h-4" />
              </Link>
            </Button>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {portfolioItems.map((item, index) => (
              <motion.div key={index} variants={fadeInUp}>
                <Card className="overflow-hidden bg-primary-foreground/5 border-primary-foreground/10 hover:bg-primary-foreground/10 transition-all duration-300">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                  <CardContent className="p-6">
                    <span className="text-xs font-medium text-accent uppercase tracking-wider">
                      {item.type}
                    </span>
                    <h3 className="font-heading text-xl font-semibold mt-2 mb-2 text-primary-foreground">
                      {item.title}
                    </h3>
                    <p className="text-primary-foreground/70 text-sm">{item.desc}</p>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div {...fadeInUp} className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">
              How It Works
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Getting your website up and running is simpler than you think.
            </p>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8"
          >
            {steps.map((step, index) => (
              <motion.div key={index} variants={fadeInUp} className="text-center">
                <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <step.icon className="w-8 h-8 text-primary-foreground" />
                </div>
                <div className="text-accent font-bold mb-2">Step {index + 1}</div>
                <h3 className="font-heading text-xl font-semibold text-foreground mb-2">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-sm">{step.desc}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Packages Overview */}
      <section className="py-16 md:py-24 bg-muted/30">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div {...fadeInUp} className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">
              Your Website, Your Way
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {'\u00a3'}0 upfront. Pick your plan, add the features your business needs,
              and only pay for what you use.
            </p>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8"
          >
            {packages.map((pkg, index) => (
              <motion.div key={index} variants={fadeInUp}>
                <Card
                  className={`h-full relative flex flex-col ${
                    pkg.popular
                      ? 'border-accent border-2 shadow-xl'
                      : pkg.commerce
                        ? 'border-primary border-2 shadow-lg'
                        : 'border-border/50'
                  }`}
                >
                  {pkg.popular && (
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent text-accent-foreground text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap">
                      Most Popular
                    </div>
                  )}
                  {pkg.commerce && (
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap flex items-center gap-1.5">
                      <ShoppingBag className="w-3.5 h-3.5" /> Sell Online
                    </div>
                  )}
                  <CardContent className="p-6 md:p-7 flex flex-col flex-1">
                    <h3 className="font-heading text-2xl font-bold text-foreground mb-2">
                      {pkg.name}
                    </h3>
                    <p className="text-sm text-muted-foreground mb-4">
                      {pkg.description}
                    </p>

                    <div className="flex items-baseline gap-1">
                      <span className="font-heading text-4xl font-bold text-primary">{pkg.price}</span>
                      <span className="text-lg text-muted-foreground">/month</span>
                    </div>
                    {pkg.maintainPrice && (
                      <div className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-accent/10 border border-accent/30 px-3 py-1 text-xs font-semibold text-accent">
                        <ArrowDown className="w-3.5 h-3.5" strokeWidth={2.5} />
                        Drops to {pkg.maintainPrice}/mo from year 2
                      </div>
                    )}
                    <p className="text-muted-foreground text-xs mt-2">{pkg.note}</p>
                    {pkg.eligibility && (
                      <p className="text-xs mt-1 mb-6 text-amber-700 font-medium">
                        {pkg.eligibility}
                      </p>
                    )}
                    {!pkg.eligibility && <div className="mb-6" />}

                    <ul className="space-y-3 mb-8 flex-1">
                      {pkg.features.map((feature, i) => (
                        <li key={i} className="flex items-start gap-3 text-sm">
                          <Check className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                          <span className="text-foreground">{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <Button
                      asChild
                      data-testid={`pricing-${pkg.name.toLowerCase().replace(/\s+/g, '-')}-btn`}
                      className={`w-full rounded-full ${pkg.popular ? 'bg-accent text-accent-foreground hover:bg-accent/90' : 'bg-primary text-primary-foreground hover:bg-primary/90'}`}
                    >
                      <Link to="/contact">{pkg.cta}</Link>
                    </Button>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </motion.div>
          <motion.div {...fadeInUp} className="text-center mt-10 max-w-2xl mx-auto">
            <p className="text-muted-foreground text-sm">
              All plans include hosting, security, SEO, analytics, admin portal, and ongoing support.
              Add features like bookings, blog, gallery, email marketing and online store as you need them.
            </p>
            <Link to="/pricing" className="text-accent hover:underline text-sm font-medium mt-2 inline-block">
              View full pricing &amp; add-ons
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Testimonials */}
      {/*<section className="py-16 md:py-24">*/}
      {/*  <div className="max-w-7xl mx-auto px-6 md:px-12">*/}
      {/*    <motion.div {...fadeInUp} className="text-center mb-12">*/}
      {/*      <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">*/}
      {/*        What Our Clients Say*/}
      {/*      </h2>*/}
      {/*    </motion.div>*/}
      {/*    <motion.div*/}
      {/*      variants={staggerContainer}*/}
      {/*      initial="initial"*/}
      {/*      whileInView="whileInView"*/}
      {/*      viewport={{ once: true }}*/}
      {/*      className="grid md:grid-cols-2 gap-8"*/}
      {/*    >*/}
      {/*      {testimonials.map((testimonial, index) => (*/}
      {/*        <motion.div key={index} variants={fadeInUp}>*/}
      {/*          <Card className="h-full border-border/50">*/}
      {/*            <CardContent className="p-6 md:p-8">*/}
      {/*              <Quote className="w-10 h-10 text-accent/30 mb-4" />*/}
      {/*              <p className="text-lg text-foreground mb-6 italic">*/}
      {/*                "{testimonial.quote}"*/}
      {/*              </p>*/}
      {/*              <div className="flex items-center gap-4">*/}
      {/*                <img*/}
      {/*                  src={testimonial.image}*/}
      {/*                  alt={testimonial.name}*/}
      {/*                  className="w-12 h-12 rounded-full object-cover"*/}
      {/*                />*/}
      {/*                <div>*/}
      {/*                  <p className="font-semibold text-foreground">{testimonial.name}</p>*/}
      {/*                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>*/}
      {/*                </div>*/}
      {/*              </div>*/}
      {/*            </CardContent>*/}
      {/*          </Card>*/}
      {/*        </motion.div>*/}
      {/*      ))}*/}
      {/*    </motion.div>*/}
      {/*  </div>*/}
          {/*</section>*/}

          {/* Here from us */}
          <section className="py-16 md:py-24">
              <div className="max-w-7xl mx-auto px-6 md:px-12">
                  <motion.div {...fadeInUp} className="text-center mb-12">
                      <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">
                        Hear from us
                      </h2>
                  </motion.div>
                  <motion.div
                      variants={staggerContainer}
                      initial="initial"
                      whileInView="whileInView"
                      viewport={{ once: true }}
                      className="grid md:grid-cols-2 gap-8"
                  >
                      {hereFromUs.map((us, index) => (
                          <motion.div key={index} variants={fadeInUp}>
                              <Card className="h-full border-border/50">
                                  <CardContent className="p-6 md:p-8">
                                      <Quote className="w-10 h-10 text-accent/30 mb-4" />
                                      <p className="text-lg text-foreground mb-6 italic">
                                          "{us.quote}"
                                      </p>
                                      <div className="flex items-center gap-4">
                                          <img
                                              src={us.image}
                                              alt={us.name}
                                              className="w-24 h-24 rounded-full object-cover"
                                          />
                                          <div>
                                              <p className="font-semibold text-foreground">{us.name}</p>
                                              <p className="text-sm text-muted-foreground">{us.role}</p>
                                          </div>
                                      </div>
                                  </CardContent>
                              </Card>
                          </motion.div>
                      ))}
                  </motion.div>
              </div>
          </section>

      {/* Final CTA */}
      <section className="py-16 md:py-24 bg-accent/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <motion.div {...fadeInUp}>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6">
              Need a better website?
            </h2>
            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              Let's chat about what you need. No pressure, just a friendly conversation 
              about how we can help your business grow online.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                asChild
                data-testid="final-cta-quote-btn"
                className="bg-accent text-accent-foreground hover:bg-accent/90 rounded-full px-8 py-6 text-lg font-medium shadow-md"
              >
                <Link to="/contact">Request a Quote</Link>
              </Button>
              <Button
                asChild
                variant="outline"
                data-testid="final-cta-call-btn"
                className="rounded-full px-8 py-6 text-lg font-medium border-2"
              >
                <Link to="/contact">Book a Call</Link>
              </Button>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;
